/**
 * Client-side loader for public analytics IDs — fetched from /api/config so that
 * IDs can be rotated by editing /app/backend/.env without a redeploy.
 * Injects: Google Analytics (gtag), Meta Pixel, and a GSC verification meta tag.
 */
export async function bootstrapAnalytics(apiBase) {
    try {
        const res = await fetch(`${apiBase}/api/config`, { cache: "no-store" });
        if (!res.ok) return;
        const cfg = (await res.json()).analytics || {};
        if (cfg.ga_measurement_id) injectGA(cfg.ga_measurement_id);
        if (cfg.meta_pixel_id) injectMetaPixel(cfg.meta_pixel_id);
        if (cfg.gsc_verification) injectGSCMeta(cfg.gsc_verification);
    } catch (_) {
        /* noop */
    }
}

function injectGA(id) {
    if (document.getElementById("ga-script")) return;
    const s = document.createElement("script");
    s.id = "ga-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    const i = document.createElement("script");
    i.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${id}');`;
    document.head.appendChild(i);
}

function injectMetaPixel(id) {
    if (window.fbq) return;
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", id);
    window.fbq("track", "PageView");
}

function injectGSCMeta(content) {
    if (document.querySelector('meta[name="google-site-verification"]')) return;
    const m = document.createElement("meta");
    m.name = "google-site-verification";
    m.content = content;
    document.head.appendChild(m);
}
